export const SocialPostPieceNames = {
  Title: 'Title',
  Description: 'Description',
  ImagePreview: 'Image Preview',
  Image: 'Image',
  Message: 'message',
  PersonalMessage: 'Personal Message (Optional)',
  Layout: 'layout',
  CallToAction: 'Call To Action',
  Caption: 'Caption',
  Link: 'Link',
};
